import {
  InnerBlocks,
  useBlockProps,
  useInnerBlocksProps,
} from '@wordpress/block-editor';

import ResponsiveImage from '@components/ui/ResponsiveImage';
import ResponsiveVideo from '@components/ui/ResponsiveVideo';

import classNames from 'classnames';

export default function save({ attributes }) {
  const { media, mediaClass, linkUrl, linkTitle, linkTarget } = attributes;

  // set classes
  const blockProps = useBlockProps.save({
    className: `overflow-hidden bf_relative`,
  });

  // set inner blocks as banner wrapper
  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: `bf_z-10 bf_absolute bf-top-0 bf_left-0 bf_w-full bf_h-full bf_lex bf_items-center bf_justify-center`,
  });

  return (
    <div {...blockProps}>
      {media.type === 'video' ? (
        <ResponsiveVideo media={media} mediaClass={mediaClass} />
      ) : (
        <ResponsiveImage media={media} mediaClass={mediaClass} />
      )}
      {linkUrl ? (
        <a
          rel="noopener noreferrer"
          target={linkTarget}
          href={linkUrl}
          title={linkTitle}
          className="bf_tile"
        ></a>
      ) : null}
    </div>
  );
}
